<template>
  <div class='full-screen ct-flex-column'>
    <TheHeader class='the-header' />
    <router-view class='item-flex-full' />
    <TheToast />
    <TheLoading />
    <Confirm />
    <Alerte />
    <Prompt />
    <Select />
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheLoading from '@/components/TheLoading.vue'
import TheToast from '@/components/TheToast.vue'
import Confirm from '@/components/Confirm.vue'
import Alerte from '@/components/Alerte.vue'
import Prompt from '@/components/Prompt.vue'
import Select from '@/components/Select.vue'

export default {
  name: 'App',
  components: { TheHeader, TheLoading, TheToast, Confirm, Alerte, Prompt, Select },
  created () {
    this.$store.commit('TOKEN', null)
    this.$store.dispatch('doInit')
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import "./assets/scss/main.scss";
</style>
